






















































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { debounce } from 'lodash-es'
import constants from '@/utils/constants'
export interface IRemoteDataField {
  key: string
  label?: string
  sortable?: boolean
  class?: string
  formatter?: any
  filter?: 'input' | 'select'
  options?: { text: string; value: any }[]
  disableFilter?: boolean
}

export class RemoteDataField implements IRemoteDataField {
  public key: string = ''
  public label?: string = ''
  public sortable?: boolean = true
  public class?: string = ''
  public formatter?: any = undefined
  public constants: any = constants
  public filter?: 'input' | 'select' = 'input'
  public options?: { text: string; value: any }[]
  public disableFilter?: boolean = false
  constructor(remoteDataField?: IRemoteDataField) {
    if (remoteDataField) {
      this.key = remoteDataField.key ? remoteDataField.key : ''
      this.label = remoteDataField.label ? remoteDataField.label : ''
      this.sortable =
        remoteDataField.sortable || remoteDataField.sortable === undefined
      this.filter = remoteDataField.filter || 'input'
      this.options = remoteDataField.options
      this.class = remoteDataField.class ? remoteDataField.class : 'text-center'
      this.formatter = remoteDataField.formatter
        ? remoteDataField.formatter
        : undefined
      this.disableFilter = remoteDataField.disableFilter
    }
  }
}

// @ts-ignore
@Component()
export default abstract class RemoteDataTable<T> extends Vue {
  // This overrides the parent component props on parent re-render so commented now. Still works normally.
  // @Prop(String) pageTitle!: string

  @Prop({
    type: Boolean,
    default: true
  })
  isEdit!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  isDelete!: boolean
  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean

  // This overrides the parent component props on parent re-render so commented now. Still works normally.
  // @Prop(Array) fieldsSet!: Array<RemoteDataField>

  showModal: boolean = false
  isVariant: boolean = false
  isVariantAddEdit: boolean = false
  selectedItem: any = null
  perPage = 20
  perPageOptions: Array<number> = [10, 20, 50, 100]
  debounceFunction: any
  itemOption: Array<any> = []
  restaurantCode: any = null
  loginID: any = ''
  showReset: boolean = true
  $swal: any
  public constants: any = constants

  constructor(props: any) {
    super(props)
    this.debounceFunction = debounce(this.reload, 1000)
  }

  mounted() {
    if (this.items.length === 0) {
      this.reload()
    }
    if (window.location.pathname === '/menu-item') {
      this.isVariant = true
    }
    if (window.location.pathname.includes('/variants-list')) {
      this.isVariantAddEdit = true
    }
    if (window.location.pathname === '/variant-category') {
      this.showReset = false
    }
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7
    }
    if (page > Math.ceil(total / this.perPage) - 5) {
      return 7
    }
    return 5
  }
  goToVariant(item) {
    const { outletCode, menuItemCode } = item
    this.$router.push(`/variants-list/${outletCode}/${menuItemCode}`)
  }
  abstract get items(): T[]

  abstract get paging(): T[]

  abstract get sorting(): T[]

  abstract get filtering(): T[]

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' })
  }

  resetFilter() {
    this.filterChanged(true)
  }

  abstract sortingChanged(ctx)

  abstract filterChanged(isResetFilter)

  abstract reload()

  abstract deleteItem(item)

  openModal(item: any = null) {
    if (!item) {
      this.selectedItem = null
      this.showModal = true
      return
    }
    this.selectedItem = { ...item }
    this.showModal = true
  }

  discardModal() {
    this.showModal = false
    this.selectedItem = null
  }

  cancelOrder(item) {
    this.$emit('cancel-order', item)
  }

  abstract setPerPage(page)

  onMaxEntriesChanged() {
    this.setPerPage(this.perPage)
  }

  get isFetchingData() {
    return this.$store.getters.GetIsFetchingData
  }

  beforeDestroy() {
    this.$store.commit('SET_IS_FETCHING_DATA', false)
  }
}
